import { IAmount } from '@/types/amount';
import { ICompany } from '@/types/company';
import {
  ITeamOverrideWithTeam,
  LearningBudgetSetupStatus,
} from '@/types/learning-budget';

import { IEmployeeOverrideWithEmployee } from '@/types/learning-budget';

export enum TableRowVariant {
  Company = 'company',
  Team = 'team',
  Employee = 'employee',
}

export type CompanyRow = {
  variant: TableRowVariant.Company;
  company: Pick<ICompany, '_id'>;
  budget: IAmount;
  setupStatus: LearningBudgetSetupStatus;
  isDirty: boolean;
};

export type TeamRow = ITeamOverrideWithTeam & {
  variant: TableRowVariant.Team;
  employeeOverrides: EmployeeRow[];
  setupStatus: LearningBudgetSetupStatus;
  isDirty: boolean;
};

export type EmployeeRow = IEmployeeOverrideWithEmployee & {
  variant: TableRowVariant.Employee;
  setupStatus: LearningBudgetSetupStatus;
  isDirty: boolean;
};
